<template>
  <v-form ref="workshopEditForm" v-model="valid">
    <div class="back-btn" @click="$router.push({name: 'delivery-index', params: {tab: 3}})">
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M36 27H23.83L29.42 21.41L28 20L20 28L28 36L29.41 34.59L23.83 29H36V27Z" fill="#8C959D"/>
      </svg>
    </div>
    <v-row>
      <v-col  cols="12" sm="5" md="4" xl="3">
        <h1 class="mb-16">{{ workshop.id ? 'Редактировать цех' : 'Создать цех'}}</h1>
        <v-text-field
                v-model="workshop.name"
                label="Название"
                :rules="[rules.required]"
                required
                outlined
        ></v-text-field>
        <v-text-field
            v-model="workshop.name_for_order_type"
            label="Название для типов заказа"
            required
            outlined
        ></v-text-field>
        <v-dialog
                ref="timeDialog"
                v-model="timeModal"
                :return-value.sync="workshop.default_delivery_time"
                width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                    v-model="workshop.default_delivery_time"
                    label="Время доставки"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
            ></v-text-field>
          </template>
          <v-time-picker
                  v-model="workshop.default_delivery_time"
                  full-width
                  format="24hr"
          >
            <v-spacer></v-spacer>
            <v-btn
                    text
                    color="primary"
                    @click="timeModal = false"
            >
              Cancel
            </v-btn>
            <v-btn
                    text
                    color="primary"
                    @click="$refs.timeDialog.save(workshop.default_delivery_time  )"
            >
              OK
            </v-btn>
          </v-time-picker>
        </v-dialog>
        <v-checkbox
            v-model="workshop.is_order_type"
            label="Использовать для типов заказа"
        ></v-checkbox>
          <v-text-field
              v-model="workshop.priority"
              label="Приоритет для типов заказа"
              outlined
          ></v-text-field>
        <v-btn :loading="loadingButton" v-if="id" @click="update">Сохранить</v-btn>
        <v-btn :loading="loadingButton" v-else @click="create">Создать</v-btn>
      </v-col>
      <v-snackbar
              v-model="snackbar"
              :timeout="timeout"
              :color="snackbarColor"
              right
              top
      >
        {{ snackbarText }}
      </v-snackbar>
    </v-row>
  </v-form>
</template>

<script>
  // @ is an alias to /src
  import WorkshopService from "../../../api/WorkshopService";
  import moment from 'moment'

  export default {
    name: 'WorkshopEdit',
    props: {
        id: {
            default: null,
        }
    },
    components: {},
    data: () => ({
      snackbar: false,
      timeout: 2000,
      snackbarText: '',
      valid: true,
      snackbarColor: '',
      timeModal: false,
      tabLang: '',
      rules: {
        required: value => !!value || 'Нужно заполнить',
        requiredSelect: [(v) => !!v.id || 'Нужно заполнить'],
      },
      workshop: {
          name: '',
          name_for_order_type: '',
          is_order_type: false,
          priority: 999,
          default_delivery_time: '00:00',
          delivery_time: '00:00'

      },
      loading: true,
      loadingButton: false,
    }),
    mounted() {
      this.init();
    },
    methods: {
      validate () {
        this.$refs.workshopEditForm.validate()
      },
      init(){
        if(this.id) {
          WorkshopService.get(this.id)
            .then(response => {
              this.workshop = response.data;
              this.loading = false
            });
        }
      },
      update(){
        this.validate()
        if(!this.valid){
          return false
        }
        this.loadingButton = true;
        let formData = this.getData();

        WorkshopService.update(formData).then(response => {
          this.snackbar = true;
          this.snackbarText = 'Цех успешно обновлен';
          this.snackbarColor = 'success';
        }).catch(error => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка при обновлении цеха';
          this.snackbarColor = 'error';
        }).finally(() => {
          this.loadingButton = false
        })
      },
      create(){
        this.validate()
        if(!this.valid){
          return false
        }
        this.loadingButton = true;
        var formData = this.getData();

        WorkshopService.create(formData).then(response => {
          this.snackbar = true;
          this.snackbarText = 'Цех успешно создан';
          this.snackbarColor = 'success';
          this.$router.push({ name: 'workshop-edit', params: { id: response.data.id } })
          this.init();
        }).catch(error => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка при создании цеха';
          this.snackbarColor = 'error';
        }).finally(() => {
          this.loadingButton = false
        })
      },
      getData() {
        let formData = new FormData();
        let time = moment('2020-01-01 ' + this.workshop.default_delivery_time).format('HH:mm:ss')

        formData.append('id', this.id);
        formData.append('name', this.workshop.name);
        formData.append('name_for_order_type', this.workshop.name_for_order_type);
        formData.append('is_order_type', this.workshop.is_order_type ? 1 : 0);
        formData.append('priority', this.workshop.priority);
        formData.append('default_delivery_time', time);
        formData.append('delivery_time', time);

        return formData;
      }
    },
  }
</script>

<style scoped lang="scss">
  .image-placeholder{
    width: 100%;
    height: 100%;
    background-color: #F3F7FC;
    border-radius: 4px;
  }
  .workshop-images .v-image{
    max-height: 374px;
  }
  .workshop{
    position: relative;
    &:before{
      content: "";
      padding-top: 100%;
      display: block;
    }

    .content{
      position: absolute;
      width: 100%;
      left: 0;
      top: 0;
      height: 100%;
      background-color: #F8FBFF;
      border-right-style: 3px;
      .img{
        height: 3.541vw;
        margin-top: .83vw;
      }
      .name{
        margin-top: .72vw;
        text-align: center;
        color: #8C959D;
      }
    }
  }
</style>
